import { useEffect } from 'react';

export default function useEscape(onCancel, target = document) {
  useEffect(() => {
    function onKeyDown(e) {
      if (/esc(ape)?/i.test(e.key) && onCancel) {
        e.preventDefault();
        e.stopPropagation();
        onCancel();
      }
    }
    if (target) {
      target.addEventListener('keydown', onKeyDown, true);
    }
    return () => {
      if (target) {
        target.removeEventListener('keydown', onKeyDown, true);
      }
    };
  }, [onCancel, target]);
}
